<template>
  <div>
    <div class="tabnavBox">
      <transition-group name="list" tag="ul">
        <li v-for="(item, index) in $store.state.tabnavBox" @contextmenu.prevent="openMenu(item,$event,index)"
            :key="item.path" class="tabnav" :class="{ active: $route.fullPath === item.path }">
          <router-link :to="item.path">{{item.title}}</router-link>
          <i @click="removeTab(item)" class="el-icon-error" v-if="index !== 0"></i>
        </li>
      </transition-group>
    </div>
    <ul v-show="this.rightMenuShow" :style="{left:this.left+'px',top:this.top+'px'}" class="menuBox">
      <li @click="removeTab($store.state.rightNav)">关闭当前页面</li>
      <li @click="removeOtherTab($store.state.rightNav)">关闭其他页面</li>
      <li @click="removeAllTab">关闭全部页面</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'tabNav',
    data () {
      return {
        rightMenuShow: false,
        left: 0,
        top: 0
      }
    },
    methods: {
      openMenu (item, e, index) {
        if (index === 0) {
          return false
        }
        let l = this.$store.state.isCollapse ? 60 : 200
        this.rightMenuShow = true
        this.left = e.clientX -l
        this.top = e.clientY - 55
        this.$store.dispatch('openMenu', item)
      },
      removeTab (tabItem) {
        this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router});
      },
      removeOtherTab (tabItem) {
        this.$store.dispatch('removeOtherTab', {tabItem, router: this.$router})
      },
      removeAllTab () {
        this.$store.dispatch('removeOtherTab', {all: true, router: this.$router})
      }
    },
    watch: {
      rightMenuShow (value) {
        if (value) {
          document.body.addEventListener('click', () => {
            this.rightMenuShow = false
          })
        } else {
          document.body.removeEventListener('click', () => {
            this.rightMenuShow = false
          })
        }
      }
    },
    mounted () {
      // console.log(this.$store.state.tabnavBox)
    }
  }
</script>

<style lang="scss" scoped>
  $top: top;
  $bottom: bottom;
  $left: left;
  $right: right;
  $leftright: ($left, $right);

  %w100 {
    width: 100%;
  }

  %h100 {
    height: 100%;
  }

  %cursor {
    cursor: pointer;
  }

  @mixin set-value($side, $value) {
    @each $prop in $leftright {
      #{$side}-#{$prop}: $value;
    }
  }

  .tabnavBox {
    @extend %w100;
    height: 42px;
    min-height: 42px;
    overflow: hidden;
    background: #fff;
    border-#{$top}: 1px solid #f6f6f6;
    border-#{$bottom}: 1px solid #d8dce5;

    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    ul {
      display: flex;
      justify-content: flex-start;
      padding-#{$left}: 10px;
      padding-#{$right}: 10px;
      flex-wrap: nowrap;
      overflow-x: auto;
      li {
        position: relative;
        height: 30px;
        line-height: 31px;
        @extend %cursor;
        margin-#{$top}: 6px;
        margin-#{$right}: 5px;

        border: 1px solid #cccccc;

        overflow: hidden;
        &:not(:first-child) {
          min-width: 80px;
        }
        &:first-child a{
          flex: 0 0 auto;
          width: 60px;
          padding: 0;
          text-align: center;
        }
        &:last-child{
          margin-#{$right}: 0;
        }
        a {
          // @include set-value(padding, 13px);
          display: block;
          padding: 0 25px 0 10px;
          @extend %h100;
          font-size: 12px;
          color: #999999;
        }

        i {
          position: absolute;
          top: 7px;
          right: 5px;
          @extend %cursor;
          &:hover {
            color: red;
          }
        }
      }
      li.active {
        background: $color;
        color: #ffffff;
        a {
          color: #ffffff;
        }
      }
    }
  }

  .menuBox {
    margin: 0;
    background: #fff;
    z-index: 999;
    position: absolute;
    padding: 5px 0;
    border: 1px solid #cccccc;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 1px 6px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      @extend %cursor;
      &:hover {
        background: #e1e6ea;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/tabNav.vue